export default {
  profileSelector: {
    activeProfile: 'Aktiv'
  }
}
